import { render, staticRenderFns } from "./CampDetailKeywordDesc.vue?vue&type=template&id=4815c9cc"
import script from "./CampDetailKeywordDesc.vue?vue&type=script&lang=js"
export * from "./CampDetailKeywordDesc.vue?vue&type=script&lang=js"
import style0 from "./CampDetailKeywordDesc.vue?vue&type=style&index=0&id=4815c9cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports